<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header
      title="Panel administratora" />

    <d-row class="mt-4 mb-4">
      <d-col cols="6">
        <d-card>
          <d-card-body>
            <h4 class="text-center mb-0 mt-0">
              <router-link to="/admin/users">
                Użytkownicy
              </router-link>
            </h4>
          </d-card-body>
        </d-card>
      </d-col>

      <d-col cols="6">
        <d-card>
          <d-card-body>
            <h4 class="text-center mb-0 mt-0">
              <router-link to="/admin/product-types">
                Kategorie produktów
              </router-link>
            </h4>
          </d-card-body>
        </d-card>
      </d-col>

      <d-col cols="6" class="mt-4">
        <d-card>
          <d-card-body>
            <h4 class="text-center mb-0 mt-0">
              <router-link to="/admin/statuses">
                Statusy produktów
              </router-link>
            </h4>
          </d-card-body>
        </d-card>
      </d-col>
      <!--
      <d-col cols="4">
        <d-card>
          <d-card-body>
            <h4 class="text-center mb-0 mt-0">
              <router-link to="/admin/units">
                Jednostki/typy bułek
              </router-link>
            </h4>
          </d-card-body>
        </d-card>
      </d-col>
      -->
    </d-row>
  </d-container>
</template>

<script>
export default {
  name: 'admin',
  data() {
    return {

    };
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
};
</script>

